import L from 'leaflet';

// leaflet.markercluster uses 'L' as an implicit global variable rather than requiring it as a
// module dependency. In Vite 8 (Rolldown), module scopes are isolated — L no longer leaks from
// leaflet's module into markercluster's factory via a shared chunk scope as it did in Vite 7.
// Import this file *before* importing leaflet.markercluster to ensure L is available globally.
// See https://vasttrafik.atlassian.net/browse/NV-8288 for more details.
(globalThis as typeof globalThis & { L: typeof L }).L = L;
